import { BottomSheet, Box, Button, List, ListItemV2, Popover, useMediaQueryContext } from "@drone-js/core";
import { Fragment, memo } from "react";

export interface DynamicMenuItem {
    id: string;
    title: string;
    disabled?: boolean;
    href?: string;
    onClick?: () => void;
    dataElementName?: string;
    dataTestId?: string;
}

export interface DynamicMenuProps {
    title: string;
    items: DynamicMenuItem[];
    open: boolean;
    dataElementName?: string;
    dataTestId?: string;
    onToggle: () => void;
    dataPropertyId?: number;
    dataOnboardingId?: string;
}

export const DynamicMenu = memo<DynamicMenuProps>(function DynamicMenu({
    title,
    items,
    open,
    dataElementName,
    dataTestId,
    onToggle,
    dataPropertyId,
    dataOnboardingId,
}) {
    const context = useMediaQueryContext();

    const button = (
        <Button
            variant="icon"
            size="m"
            hierarchy="secondary"
            leadingIcon="fill.symbol.more2"
            onClick={onToggle}
            data-element-name={dataElementName}
            data-testid={dataTestId}
            data-property-id={dataPropertyId}
            data-onboarding-id={dataOnboardingId}
        />
    );
    const menuContent = (
        <Fragment>
            <List>
                {items.map((item) => (
                    <ListItemV2
                        key={item.id}
                        {...item}
                        data-element-name={item.dataElementName}
                        data-testid={item.dataTestId}
                    />
                ))}
            </List>
            {context.m && <Box mb="-16">&nbsp;</Box>}
        </Fragment>
    );

    if (context.m)
        return (
            <Popover
                content={menuContent}
                visible={open}
                onVisibilityChange={onToggle}
                hasInteractiveContent={true}
                p="m"
            >
                {button}
            </Popover>
        );

    return (
        <Fragment>
            {button}
            <BottomSheet
                title={title}
                visible={open}
                onChange={onToggle}
                closeButton={{
                    "aria-label": "Close",
                }}
            >
                {menuContent}
            </BottomSheet>
        </Fragment>
    );
});
